import * as React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  List,
  ListItem,
  SwipeableDrawer,
  Typography,
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import SettingsIcon from '@mui/icons-material/Settings';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import ReferIcon from '@mui/icons-material/GroupAdd';
import { useNavigate } from 'react-router-dom';
import {
  LOGIN,
  SIGNUP,
  AUTHROOT,
  PROFILE,
  SUBSCRIPTION,
  BILLING,
  LTVLIBHOME,
  REFER,
} from '../../routes/CONSTANTS';
import {
  selectIsLoggedIn,
  selectUserFirstName,
  selectUserLastName,
} from '../auth/UserSlice';
import { handleLogout } from '../auth/AuthService';

export default function MobileNav() {
  const [openDrawer, setOpenDrawer] = useState(false);
  let navigate = useNavigate();
  const loggedIn = useSelector(selectIsLoggedIn);
  const userFirstName = useSelector(selectUserFirstName);
  const userLastName = useSelector(selectUserLastName);

  return (
    <>
      <Button
        onClick={() => {
          setOpenDrawer(true);
        }}
      >
        <MenuIcon />
      </Button>
      <SwipeableDrawer
        anchor='top'
        open={openDrawer}
        onOpen={() => setOpenDrawer(true)}
        onClose={() => setOpenDrawer(false)}
        disableScrollLock={true}
      >
        <List>
          <ListItem>
            <Button
              onClick={() => {
                setOpenDrawer(false);
              }}
            >
              <CloseIcon />
            </Button>
          </ListItem>
          {loggedIn ? (
            <>
              <ListItem>
                <Button
                  id='auth-home-button'
                  onClick={() => {
                    navigate(AUTHROOT);
                    setOpenDrawer(false);
                  }}
                >
                  MEMBER HOME
                </Button>
              </ListItem>
              <ListItem>
                <Button
                  id='library-button'
                  onClick={() => {
                    navigate(LTVLIBHOME);
                    setOpenDrawer(false);
                  }}
                >
                  LINKTIVITY LIBRARY
                </Button>
              </ListItem>
              <ListItem>
                <AccountCircleIcon style={{ marginRight: '5' }} />
                <Typography>{userFirstName + ' ' + userLastName}</Typography>
              </ListItem>
              <ListItem>
                <List disablePadding>
                  <ListItem>
                    <Button
                      id='profile-button'
                      onClick={() => {
                        navigate(PROFILE);
                        setOpenDrawer(false);
                      }}
                      style={{ marginLeft: '40' }}
                    >
                      <PersonIcon style={{ marginRight: '10' }} />
                      PROFILE
                    </Button>
                  </ListItem>
                  <ListItem>
                    <Button
                      onClick={() => {
                        navigate(SUBSCRIPTION);
                        setOpenDrawer(false);
                      }}
                    >
                      <SettingsIcon style={{ marginRight: '10' }} />
                      Subscription
                    </Button>
                  </ListItem>
                  <ListItem>
                    <Button
                      onClick={() => {
                        navigate(BILLING);
                        setOpenDrawer(false);
                      }}
                    >
                      <CreditCardIcon style={{ marginRight: '10' }} />
                      Billing
                    </Button>
                  </ListItem>
                  <ListItem>
                    <Button
                      onClick={() => {
                        navigate(REFER);
                        setOpenDrawer(false);
                      }}
                    >
                      <ReferIcon style={{ marginRight: '10' }} />
                      Refer a Friend
                    </Button>
                  </ListItem>
                  <ListItem>
                    <Button
                      id='logout-button'
                      onClick={() => {
                        handleLogout();
                        setOpenDrawer(false);
                      }}
                    >
                      <LogoutIcon style={{ marginRight: '10' }} />
                      LOGOUT
                    </Button>
                  </ListItem>
                </List>
              </ListItem>
            </>
          ) : (
            <>
              <ListItem>
                <Button
                  id='library-preview-button'
                  onClick={() => {
                    navigate(LTVLIBHOME);
                    setOpenDrawer(false);
                  }}
                >
                  LIBRARY PREVIEW
                </Button>
              </ListItem>
              <ListItem>
                <Button
                  id='sign-up-button'
                  onClick={() => {
                    navigate(SIGNUP);
                    setOpenDrawer(false);
                  }}
                >
                  SIGN UP
                </Button>
              </ListItem>
              <ListItem>
                <Button
                  id='login-button'
                  onClick={() => {
                    navigate(LOGIN);
                    setOpenDrawer(false);
                  }}
                >
                  MEMBER LOGIN
                </Button>
              </ListItem>
            </>
          )}
        </List>
      </SwipeableDrawer>
    </>
  );
}
